import { Button, TextButton } from '@creditornot/cb-button';
import { Modal, BREAKPOINT_MOBILE_MAX } from '@creditornot/cbt-modal';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { DiscountedItem, DiscountedItemCategory } from 'modules/campaigns/hooks/useDiscountedItems';

import { SelectedDiscountedItemsModalContent } from './SelectedDiscountedItemsModalContent';

type SelectedDiscountedItemsModalProps = {
  discountedItems: DiscountedItem[];
  selectedCategories: DiscountedItemCategory[];
  selectedOtherItemIds: string[];
  selectedCategoriesCount: number;
  totalSelectedItemsCount: number;
  selectedCategoryIds: string[];
  onEditClick?: () => void;
};

const Footer = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
`;

const StyledButton = styled(Button)`
  @media (width <= ${BREAKPOINT_MOBILE_MAX}px) {
    flex: 1 1 50%;
  }
`;

export const SelectedDiscountedItemsModal = ({
  discountedItems,
  selectedCategories,
  selectedOtherItemIds,
  selectedCategoriesCount,
  totalSelectedItemsCount,
  selectedCategoryIds,
  onEditClick,
}: SelectedDiscountedItemsModalProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { formatMessage } = useIntl();

  return (
    <>
      <TextButton onClick={() => setIsOpen(true)}>
        {selectedCategoriesCount ? (
          <FormattedMessage
            id="campaigns.form.item.view-all-items-categories"
            values={{
              items: totalSelectedItemsCount,
              categories: selectedCategoriesCount,
            }}
          />
        ) : (
          <FormattedMessage
            id="campaigns.form.item.view-all-items"
            values={{
              count: totalSelectedItemsCount,
            }}
          />
        )}
      </TextButton>
      <Modal
        open={isOpen}
        onDismiss={() => setIsOpen(false)}
        title={
          selectedCategoriesCount
            ? formatMessage(
                { id: 'campaigns.form.item.showing-count-items-categories' },
                { items: totalSelectedItemsCount, categories: selectedCategoriesCount },
              )
            : formatMessage({ id: 'campaigns.form.item.showing-count-items' }, { count: totalSelectedItemsCount })
        }
        sizeConfig={{
          desktop: {
            type: 'centered',
            width: '100%',
            maxWidth: '800px',
            height: '100%',
            maxHeight: '700px',
          },
          mobile: { type: 'fullScreen' },
        }}
        disableContentPadding
        footer={
          !!onEditClick && (
            <Footer>
              <StyledButton variant="secondary" size="small" onClick={() => setIsOpen(false)}>
                <FormattedMessage id="state.cancel" />
              </StyledButton>
              <StyledButton
                variant="primary"
                size="small"
                onClick={() => {
                  setIsOpen(false);
                  onEditClick();
                }}
              >
                <FormattedMessage id="campaigns.form.item.edit-selection" />
              </StyledButton>
            </Footer>
          )
        }
      >
        <SelectedDiscountedItemsModalContent
          discountedItems={discountedItems}
          selectedCategories={selectedCategories}
          selectedOtherItemIds={selectedOtherItemIds}
          selectedCategoryIds={selectedCategoryIds}
          totalSelectedItemsCount={totalSelectedItemsCount}
        />
      </Modal>
    </>
  );
};
